export enum PlanName {
  // - archived plans
  // TODO: once clean up the organization's subscription
  // (i.e. move away from these legacy plans), remove from this enum list
  ArchivedStartupMonthly = 'archived-startup-monthly',
  ArchivedTeamsYearly = 'archived-teams-yearly',
  ArchivedTeamsMonthly2 = 'archived-teams-monthly-2',
  StartupYearly = 'startup_yearly',
  StartupMonthly = 'startup_monthly',
  /**
   * Refers to legacy plan unrelated to Teams plan instated in 2023.
   * @deprecated Use MonthlyTeams2023 to refer to current Teams plan.
   */
  TeamsMonthly = 'teams_monthly',
  /**
   * Refers to legacy plan unrelated to Teams plan instated in 2023.
   * @deprecated Use YearlyTeams2023 to refer to current Teams plan.
   */
  TeamsYearly = 'teams_yearly',
  StandardMonthly = 'standard_monthly',
  StandardYearly = 'standard_yearly',
  // - active plans that are promoted to users in app
  Enterprise = 'enterprise',
  StorageMonthly = 'storage_monthly',
  TrackingMonthly = 'tracking_monthly',
  Basic = 'basic',
  StarterTier1Monthly = 'starter_tier_1_monthly',
  StarterTier1Yearly = 'starter_tier_1_yearly',
  StarterTier2Monthly = 'starter_tier_2_monthly',
  StarterTier2Yearly = 'starter_tier_2_yearly',
  StarterTier3Monthly = 'starter_tier_3_monthly',
  StarterTier3Yearly = 'starter_tier_3_yearly',
  YearlyTeams2023 = 'yearly_teams_2023',
  MonthlyTeams2023 = 'monthly_teams_2023',
  YearlyHour2023 = 'yearly_hour_2023',
  MonthlyHour2023 = 'monthly_hour_2023',
  MonthlyStorage2023 = 'monthly_storage_2023',
  MonthlyStorage200GB = 'monthly_storage_200gb',
  CommunityEdition = 'community_edition',
  TrialPlan = 'trial_plan',
  TrackingHours2023 = 'tracking_hours_2023',
  WeaveAnnual1500 = 'weave_annual_1500mb',
  WeaveAnnual2000 = 'weave_annual_2000mb',
  WeaveAnnual3500 = 'weave_annual_3500mb',
  WeaveAnnual5000 = 'weave_annual_5000mb',
  WeaveAnnual6500 = 'weave_annual_6500mb',
  WeaveAnnual8000 = 'weave_annual_8000mb',
  WeaveAnnual10000 = 'weave_annual_10000mb',
  WeaveAnnual12500 = 'weave_annual_12500mb',
  WeaveAnnual15000 = 'weave_annual_15000mb',
  WeaveAnnual20000 = 'weave_annual_20000mb',
  WeaveAnnual25000 = 'weave_annual_25000mb',
  WeaveAnnual30000 = 'weave_annual_30000mb',
  WeaveAnnual35000 = 'weave_annual_35000mb',
  WeaveMonthly1500 = 'weave_monthly_1500mb',
  WeaveMonthly2000 = 'weave_monthly_2000mb',
  WeaveMonthly3500 = 'weave_monthly_3500mb',
  WeaveMonthly5000 = 'weave_monthly_5000mb',
  WeaveMonthly6500 = 'weave_monthly_6500mb',
  WeaveMonthly8000 = 'weave_monthly_8000mb',
  WeaveMonthly10000 = 'weave_monthly_10000mb',
  WeaveMonthly12500 = 'weave_monthly_12500mb',
  WeaveMonthly15000 = 'weave_monthly_15000mb',
  WeaveMonthly20000 = 'weave_monthly_20000mb',
  WeaveMonthly25000 = 'weave_monthly_25000mb',
  WeaveMonthly30000 = 'weave_monthly_30000mb',
  WeaveMonthly35000 = 'weave_monthly_35000mb',
  WeaveUsage1500 = 'weave_monthly_usage_1500mb',
  WeaveUsage2000 = 'weave_monthly_usage_2000mb',
  WeaveUsage3500 = 'weave_monthly_usage_3500mb',
  WeaveUsage5000 = 'weave_monthly_usage_5000mb',
  WeaveUsage6500 = 'weave_monthly_usage_6500mb',
  WeaveUsage8000 = 'weave_monthly_usage_8000mb',
  WeaveUsage10000 = 'weave_monthly_usage_10000mb',
  WeaveUsage12500 = 'weave_monthly_usage_12500mb',
  WeaveUsage15000 = 'weave_monthly_usage_15000mb',
  WeaveUsage20000 = 'weave_monthly_usage_20000mb',
  WeaveUsage25000 = 'weave_monthly_usage_25000mb',
  WeaveUsage30000 = 'weave_monthly_usage_30000mb',
  WeaveUsage35000 = 'weave_monthly_usage_35000mb',
  TrackedHoursUsage500 = 'tracked_hours_monthly_usage_500',
  TrackedHoursUsage1000 = 'tracked_hours_monthly_usage_1000',
  ModelsSeatsAnnual = 'models_seats_annual',
  ProAnnual = 'pro_plan_annual',
  ProMonthly = 'pro_plan_monthly',
  InferenceUsage500 = 'inference_monthly_usage_500',
  InferenceUsage200 = 'inference_monthly_usage_200',
  WbAgentUsage1000 = 'wb_agent_monthly_usage_1000',
  SandboxesUsage0 = 'sandboxes_monthly_usage_0',
  SandboxesUsage3000 = 'sandboxes_monthly_usage_3000',
}
